/* Sherri Hill 2026 — homepage (sections/sh2-home-*.liquid).
   1. Hero film: the only autoplaying video on the site. Muted, looped, with a pause control. It mounts after the
      poster has painted; under reduced motion or Save-Data it stays a poster with a play control.
      Source is either a Shopify-hosted MP4 or a YouTube film (desktop + phone versions).
   2. Product-row video: a card whose first media is a video mounts it near the viewport (same rule as collections).
   3. Keeps --sh2-home-top equal to the announcement bar so the film fills the first screen under the header. */
(function () {
  'use strict';

  var quiet = function () {
    return (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) ||
      (navigator.connection && navigator.connection.saveData);
  };

  /* ---------- 3. first-screen offset ---------- */
  function setTop() {
    var a = document.querySelector('.sh2-announce');
    var h = a ? a.getBoundingClientRect().height : 0;
    document.documentElement.style.setProperty('--sh2-home-top', h + 'px');
  }
  setTop();
  window.addEventListener('resize', setTop, { passive: true });

  /* ---------- 1. Hero film ---------- */
  function initHero(hero) {
    if (hero.dataset.sh2Init) return;
    hero.dataset.sh2Init = '1';
    var media = hero.querySelector('.sh2-hero__media');
    var btn = hero.querySelector('[data-sh2-hero-play]');
    var kind = hero.getAttribute('data-kind');
    var title = hero.getAttribute('data-title') || 'the';
    var player = null;
    var running = false;

    function setRunning(on) {
      running = on;
      hero.classList.toggle('is-running', on);
      if (btn) btn.setAttribute('aria-label', (on ? 'Pause ' : 'Play ') + title + ' film');
    }

    function mountMp4() {
      var v = document.createElement('video');
      v.className = 'sh2-hero__video';
      v.muted = true; v.loop = true; v.playsInline = true; v.autoplay = true; v.preload = 'auto';
      v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('aria-hidden', 'true');
      var phone = window.matchMedia('(max-width: 767px)').matches;
      v.src = (phone && hero.getAttribute('data-src-mobile')) || hero.getAttribute('data-src');
      v.addEventListener('playing', function () { hero.classList.add('is-playing'); setRunning(true); });
      v.addEventListener('pause', function () { setRunning(false); });
      media.appendChild(v);
      var p = v.play();
      if (p && p.catch) p.catch(function () { setRunning(false); });
      return {
        play: function () { var q = v.play(); if (q && q.catch) q.catch(function () {}); },
        pause: function () { v.pause(); }
      };
    }

    function mountYouTube() {
      var phone = window.matchMedia('(max-width: 767px)').matches;
      var id = (phone && hero.getAttribute('data-yt-mobile')) || hero.getAttribute('data-yt');
      var ratio = (phone && hero.getAttribute('data-yt-mobile')) ? hero.getAttribute('data-yt-mobile-ratio') : hero.getAttribute('data-yt-ratio');
      if (!id) return null;
      var f = document.createElement('iframe');
      f.className = 'sh2-hero__yt';
      if (ratio) f.style.setProperty('--r', ratio);
      f.title = title + ' film';
      f.setAttribute('aria-hidden', 'true');
      f.setAttribute('tabindex', '-1');
      f.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
      f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) +
        '?autoplay=1&mute=1&loop=1&playlist=' + encodeURIComponent(id) +
        '&controls=0&playsinline=1&rel=0&modestbranding=1&iv_load_policy=3&disablekb=1&enablejsapi=1&origin=' +
        encodeURIComponent(location.origin);
      var send = function (func) {
        try { f.contentWindow.postMessage(JSON.stringify({ event: 'command', func: func, args: [], id: 'sh2-hero', channel: 'widget' }), '*'); } catch (e) {}
      };
      window.addEventListener('message', function (e) {
        if (e.source !== f.contentWindow) return;
        var d; try { d = typeof e.data === 'string' ? JSON.parse(e.data) : e.data; } catch (x) { return; }
        if (!d) return;
        var state = d.info && typeof d.info === 'object' ? d.info.playerState : (d.event === 'onStateChange' ? d.info : undefined);
        // Show the film only while YouTube reports it playing; the poster covers YouTube's own buffering and pause screens.
        if (state === 1) { hero.classList.add('is-playing'); setRunning(true); }
        else if (state === 2 || state === 0) { hero.classList.remove('is-playing'); setRunning(false); }
      });
      f.addEventListener('load', function () {
        try { f.contentWindow.postMessage(JSON.stringify({ event: 'listening', id: 'sh2-hero', channel: 'widget' }), '*'); } catch (e) {}
      });
      media.appendChild(f);
      return { play: function () { send('playVideo'); setRunning(true); }, pause: function () { send('pauseVideo'); setRunning(false); } };
    }

    function mount() {
      if (player) return;
      player = kind === 'youtube' ? mountYouTube() : mountMp4();
    }

    if (btn) {
      btn.hidden = false;
      btn.addEventListener('click', function () {
        if (!player) { mount(); setRunning(true); return; }
        if (running) player.pause(); else player.play();
      });
    }

    if (quiet()) { setRunning(false); return; }
    var go = function () { mount(); };
    if (document.readyState === 'complete') setTimeout(go, 150);
    else window.addEventListener('load', function () { setTimeout(go, 150); });
  }

  /* ---------- 2. Product-row video ---------- */
  function mountVideo(box) {
    if (box.dataset.mounted) return;
    var src = box.getAttribute('data-src');
    if (!src) return;
    box.dataset.mounted = '1';
    var v = document.createElement('video');
    v.className = 'sh2-media__video';
    v.muted = true; v.loop = true; v.playsInline = true; v.autoplay = true; v.preload = 'auto';
    v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('aria-hidden', 'true');
    v.src = src;
    v.addEventListener('playing', function () { box.classList.add('is-playing'); });
    box.appendChild(v);
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); mountVideo(e.target); } });
  }, { rootMargin: '200px' }) : null;
  function initVideos(root) {
    root.querySelectorAll('.sh2-home [data-sh2-video]:not([data-ready])').forEach(function (box) {
      box.setAttribute('data-ready', '1');
      if (quiet() || !io) {
        var b = box.querySelector('.sh2-media__play');
        if (b) {
          b.hidden = false;
          b.addEventListener('click', function (ev) { ev.preventDefault(); ev.stopPropagation(); b.hidden = true; mountVideo(box); });
        }
        return;
      }
      io.observe(box);
    });
  }

  function init(root) {
    root.querySelectorAll('[data-sh2-hero]').forEach(initHero);
    initVideos(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
